import { createContext } from 'react'
import { PersonalizedTheme } from '@itsrever/design-system'

// Copy edits that are not saved yet, keyed "<LANG>-<copy_key>" — the shape usePortalTranslate
// merges over the stored copies. Empty means the preview renders what is saved.
export const EditedCopiesContext = createContext<Record<string, string>>({})

// Theme edits that are not saved yet. null means the preview renders the stored e-commerce
// theme, which is what a consumer that mounts no provider gets.
export const ThemeOverrideContext = createContext<PersonalizedTheme | null>(null)

// Branding the preview draws with but that does not belong to the design-system theme shape:
// the text over the background image and the logo box. Same contract as the theme override —
// null means the preview reads what is stored.
export interface BrandingOverride {
  backgroundTextColor?: string
  logoHeight?: { desktop?: string; mobile?: string }
  title?: string
  // Portal images. Either a data url an editor has picked but not uploaded, or the stored url
  // when usePortalBranding fills these in from settings — so a reader cannot tell the two apart
  // and should go through usePortalLogoUrl / usePortalBackgroundImageUrl, which resolve an unset
  // override to the stored value. The favicon is absent: no portal page renders a tab icon.
  logoUrl?: string
  backgroundImageUrl?: string
}

export const BrandingOverrideContext = createContext<BrandingOverride | null>(
  null
)

// Which device the preview is standing in for. The portal serves one page to both, but a few
// attributes resolve per breakpoint — the logo height above all — so the preview has to know
// which side of the breakpoint it is drawing.
export type PreviewDevice = 'mobile' | 'desktop'

export const PreviewDeviceContext = createContext<PreviewDevice>('mobile')
